import React from 'react'
import './style/loading.scss'

// function Loading() {
//     return (
//         <div className="loading">
//             <div className="loading-icon"></div>
//         </div>
//     )
// }


export default class Loading extends React.Component {
    componentDidMount() {
        if (document.querySelector('.__root-loading')) {
            document.querySelector('.__root-loading').removeAttribute('class')
        }
    }

    render() {
        return (
            <div className="loading">
                <div className="loading-icon"></div>
            </div>
        )
    }
}